const gInfo = window.GLOBAL_INFO || {};

export const getServiceId = () => gInfo.serviceId;

export const getReportInfo = () => gInfo.report;
